<template>
    <div>
        <v-container id="regular-tables" fluid tag="section">
            <v-simple-table :dark="$store.state.isDarkMode">
                <thead class="table-heading" v-if="!driverRoute.studentsInRouteState.loading">
                    <tr>
                        <th v-for="(name, i) in tableOptions.tableHeaders" :key="i">
                            {{ $t(name) }}
                        </th>
                    </tr>
                </thead>
                <div class="table__spinnerWrapper" v-if="driverRoute.studentsInRouteState.loading">
                    <app-spinner></app-spinner>
                </div>
                <v-fade-transition mode="out-in" :group="true" tag="tbody">
                    <tr v-for="(item, idx) in tableOptions.tableData" :key="idx"
                        v-show="!driverRoute.studentsInRouteState.loading">
                        <td>
                            {{ item.full_name }}
                        </td>
                        <td>
                            {{ item.mother_name }}
                        </td>
                        <td>
                            {{ $t(item.gender ) }}
                        </td>
                        <td>
                            {{ $t(item.type ) }}
                        </td>
                        <td>
                            {{ item.order }}
                        </td>
                        <td>
                            {{ item.time }}
                        </td>
                        <!-- <td>
                            {{ $t(item.ranking) }}
                        </td>
                        <td>
                            {{ $t(item.timeInspect) }}
                        </td> -->
                        <td>
                            <delete-student-route :item="item" ></delete-student-route>
                            <edit-student-route :item="item"></edit-student-route>

                        </td>
                    </tr>
                </v-fade-transition>
            </v-simple-table>
            <div class=" d-flex justify-end mt-5" v-if="!driverRoute.studentsInRouteState.loading">
                <app-pagination :totalPages="tableOptions.tableMeta.total" :page="tableOptions.tableMeta.page"
                    :perPage="getPerPage()" @PaginationValue="fetchNewPaginated($event)"></app-pagination>
            </div>
        </v-container>
    </div>
</template>
  
<script>
import spinner from "./spinner.vue";
import pagination from "./pagination.vue";
import { driverRoute } from '../../store/driverRoutes'
import editDriver from '../../views/dashboard/drivers/editDriver.vue'
import deleteStudentRoute from '../../views/dashboard/busRoute/deleteStudentRoute.vue'
import editStudentRoute from "../../views/dashboard/busRoute/editStudentRoute.vue";
export default {
    components: {
        appSpinner: spinner,
        appPagination: pagination,
        editDriver,
        deleteStudentRoute,
        editStudentRoute,
    },
    data() {
        return {
           
            driverRoute,
            deleteDialog: false,
            edit: false,
            item: null,
            
        };
    },

    props: {
        serverRoute: String,
        enableDelete: {
            type: Boolean,
            default: true,
        },
        flaggedItems: {
            type: Array,
            default() {
                return [];
            },
        },
        displaySettings: {
            type: Boolean,
            default: true,
        },
        tableOptions: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    created(){
      
    },
    // computed: {
    //   ...mapGetters({
    //     tableOptions: "tablesStore/getTableOptions",
    //   }),
    // },
    methods: {
        getPerPage() {
            if (this.tableOptions.tableMeta.perPage) {
                return this.tableOptions.tableMeta.perPage
            } else {
                return 10
            }
        },
        castItems(item) {
            let copyItem = { ...item };
            this.flaggedItems.forEach((el) => {
                delete copyItem[el];
            });
            return copyItem;
        },
        accessData(row, index) {
            return this.fetchAttributes(
                row,
                this.tableOptions.accessTableData[index]
            );
        },
        fetchAttributes(row, nestedKey) {
            let value = row;
            for (let key in nestedKey) {
                if (value[nestedKey[key]]) {
                    value = value[nestedKey[key]];
                } else {
                    return;
                }
            }
            return value.toLocaleString();
        },
        fetchNewPaginated(paginationValue) {
            this.$emit("re-fetch-paginated-data", paginationValue);
        },
        reFetchData() {
            this.$emit("re-fetch-data");
        },
    },
};
</script>
  
<style >

</style>